import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ExpertWorkspaceReferralInvitationDeepLinkDetailComponent } from '@sprint-expert/app/modules/expert-workspace-referral-invitation-deep-link-detail/expert-workspace-referral-invitation-deep-link-detail.component';

@Component({
  selector: 'app-expert-workspace-referral-invitation-deep-link-detail-dialog',
  standalone: true,
  imports: [ExpertWorkspaceReferralInvitationDeepLinkDetailComponent],
  template: `
    <app-expert-workspace-referral-invitation-deep-link-detail
      (byClose)="closeDialog()" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpertWorkspaceReferralInvitationDeepLinkDetailDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ExpertWorkspaceReferralInvitationDeepLinkDetailDialogComponent>
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
}
